<template>
  <div class="bg-body bg-img-dt">
    <div class="container margin-top">
      <div class="card card-login ml-auto mt-5">
        <div class="text-center mt-3">
          <img src="../../../assets/img/logo-dom.png" class="logo-dom" alt="">
        </div>
        <div class="YzXML text-center">
          <router-link class="d-block small mt-3 text-blue-dt"  to="/yzxml">YzXML</router-link>
        </div>
        <div class="card-body">
          <form @submit.prevent="onSubmit()">
            <div class="form-group">
              <div class="form-label-group">
                <input
                  type="text"
                  id="inputUsuario"
                  class="form-control"
                  placeholder="Usuário"
                  required="required"
                  autofocus="autofocus"
                  v-model="form.username"
                />
                <label for="inputUsuario">Usuário</label>
              </div>
            </div>
            <div class="form-group">
              <div class="form-label-group">
                <input
                  type="password"
                  id="inputPassword"
                  class="form-control"
                  placeholder="Senha"
                  required="required"
                  v-model="form.password"
                />
                <label for="inputPassword">Senha</label>
              </div>
            </div>
            <div class="form-group">
              <div class="checkbox">
                <label>
                  <input type="checkbox" value="remember-me">
                  Lembrar senha
                </label>
              </div>
            </div>
            <button class="btn bg-blue-dt btn-block">Login</button>
          </form>
          <div class="YzXML text-center">
            <router-link class="d-block small mt-3 text-blue-dt" to="/recover">Esqueci minha senha</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import toast from '@/methods/toast'

export default {
  data: () => ({
    form: {
      username: '',
      password: ''
    }
  }),
  created () {
  },
  methods: {
    ...mapActions('auth', ['ActionDoLogin']),
    async onSubmit () {
      try {
        await this.ActionDoLogin(this.form)
        this.$router.push({ name: 'home' })
      } catch (err) {
        toast.toastError(err.data ? err.data.message : 'Falha no login!')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .bg-body{width: 100vw; height: 100vh; position: absolute;}
  .logo-dom{width: 80%;}
  .bg-img-dt{
    background: url('../../../assets/img/bg-dom-main.png') no-repeat bottom center scroll;
    background-size: cover;
    background-color: rgb(35, 138, 197);
  }
  .margin-top{margin-top: 100px}
</style>
